import {
  AlignLeft,
  Calculator,
  Calendar,
  CircleDot,
  Clock,
  CreditCard,
  EyeOff,
  Gauge,
  Globe,
  Hash,
  Info,
  Link,
  Mail,
  MapPin,
  Paperclip,
  Phone,
  Repeat,
  SeparatorHorizontal,
  ShieldCheck,
  SquareCheck,
  SquareChevronDown,
  SquareDashed,
  Star,
  Type,
  type LucideIcon,
} from 'lucide-react'

/**
 * El icono de cada tipo de campo en la paleta y en el lienzo. Es solo dibujo: un tipo que
 * el panel no conozca (el núcleo puede añadir tipos sin tocar el panel) sale con uno
 * genérico y se usa igual.
 */
const ICONOS: Record<string, LucideIcon> = {
  texto: Type,
  area: AlignLeft,
  email: Mail,
  telefono: Phone,
  numero: Hash,
  fecha: Calendar,
  hora: Clock,
  desplegable: SquareChevronDown,
  'opcion-multiple': CircleDot,
  casillas: SquareCheck,
  archivo: Paperclip,
  direccion: MapPin,
  url: Link,
  lugar: Globe,
  valoracion: Star,
  escala: Gauge,
  consentimiento: ShieldCheck,
  oculto: EyeOff,
  informativo: Info,
  paso: SeparatorHorizontal,
  repetidor: Repeat,
  calculado: Calculator,
  pago: CreditCard,
}

export const IconoDeTipo = ({
  tipo,
  className = 'size-4',
}: {
  className?: string
  tipo: string
}) => {
  const Icono = ICONOS[tipo] ?? SquareDashed
  return <Icono aria-hidden className={className} />
}
